const asFiniteNumber = (value) => {
  if (value == null || value === '') return null;
  const parsed = typeof value === 'number' ? value : Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

const presentPracticePortfolio = (bot, snapshot) => {
  if (
    !snapshot
    || snapshot.error
    || snapshot.mode !== 'virtual_paper'
    || snapshot.execution_enabled !== false
    || !snapshot.run
    || !Array.isArray(snapshot.positions)
  ) {
    return null;
  }

  const equity = asFiniteNumber(snapshot.run.equity);
  const cash = asFiniteNumber(snapshot.run.cash);
  const realizedPnl = asFiniteNumber(snapshot.run.realized_pnl);
  if (equity == null || cash == null || realizedPnl == null) return null;

  return {
    botId: bot.id,
    botName: bot.name || `Bot ${bot.id}`,
    equity,
    cash,
    realizedPnl,
    positionCount: snapshot.positions.length,
  };
};

export const practicePortfolioOverview = (bots = [], snapshots = {}) => {
  const presented = bots.map((bot) => ({
    snapshot: snapshots[bot.id],
    portfolio: presentPracticePortfolio(bot, snapshots[bot.id]),
  }));
  const portfolios = presented.map((item) => item.portfolio).filter(Boolean);
  const unavailableCount = presented.filter(
    (item) => item.snapshot && !item.portfolio,
  ).length;

  if (portfolios.length === 0) {
    return {
      kind: 'none',
      portfolio: null,
      portfolios,
      unavailableCount,
    };
  }

  if (portfolios.length === 1) {
    return {
      kind: 'one',
      portfolio: portfolios[0],
      portfolios,
      unavailableCount,
    };
  }

  return {
    kind: 'multiple',
    portfolio: null,
    portfolios,
    unavailableCount,
  };
};

export const archivedPracticePositions = (bots = [], snapshots = {}) => {
  const portfolios = [];
  let unavailableCount = 0;

  bots.filter((bot) => bot.status === 'archived').forEach((bot) => {
    const snapshot = snapshots[bot.id];
    if (!snapshot) return; // No Practice run for this archived bot.
    if (
      snapshot.error
      || snapshot.mode !== 'virtual_paper'
      || snapshot.execution_enabled !== false
      || !snapshot.run
      || !Array.isArray(snapshot.positions)
    ) {
      unavailableCount += 1;
      return;
    }
    if (snapshot.positions.length === 0) return;

    const cash = asFiniteNumber(snapshot.run.cash);
    const equity = asFiniteNumber(snapshot.run.equity);
    const startingCapital = asFiniteNumber(snapshot.run.initial_cash);
    if (cash == null || equity == null || startingCapital == null) {
      unavailableCount += 1;
      return;
    }
    portfolios.push({
      botId: bot.id,
      botName: bot.name || `Bot ${bot.id}`,
      cash,
      equity,
      startingCapital,
      valuationRecordedAt: snapshot.run.updated_at || null,
      positions: snapshot.positions.map((position) => ({
        symbol: position.symbol,
        quantity: position.quantity,
        direction: position.position_direction,
        markPrice: position.mark_price == null ? null : asFiniteNumber(position.mark_price),
        recordedAt: position.updated_at || null,
      })),
    });
  });

  return { portfolios, unavailableCount };
};
